const commonCalc = {
  'cac-geo': {
    calc: {
      add: [
        'ele-hwc-cac',
        'ele-bwc-cac',
        'una-hwc-cac',
        'una-bwc-cac',
        'ind-cac',
      ],
      sub: ['cac-reu'],
    },
  },
  'atm-pho': {
    calc: {
      add: [
        'ele-bio-atm',
        'ele-bwc-cac',
        'una-bwc-cac',
        'rnc-bio-atm',
        'tra-bio-atm',
        'ind-bio-atm',
        'ind-neb-atm',
        'nas-nes',
      ],
    },
  },
  'pho-nas': {
    calc: {
      add: ['atm-pho'],
    },
  },
  'nas-bio': {
    calc: {
      add: [
        'ele-bio-atm',
        'rnc-bio-atm',
        'tra-bio-atm',
        'ind-bio-atm',
        'ind-neb-atm',
      ],
    },
  },
  'nas-bwc': {
    calc: {
      add: ['ele-bwc-cac', 'una-bwc-cac'],
    },
  },
  'atm-nta': {
    calc: {
      add: [
        'ele-hyc-atm',
        'ele-bio-atm',
        'una-atm',
        'rnc-hyc-atm',
        'rnc-bio-atm',
        'tra-hyc-atm',
        'tra-bio-atm',
        'ind-hyc-atm',
        'ind-bio-atm',
        'ind-pro-atm',
        'ind-neb-atm',
      ],
      sub: ['dac-geo', 'atm-pho'],
    },
  },
  'atm-dac': {
    calc: {
      add: ['dac-geo'],
    },
  },
  _capture: {
    calc: {
      add: [2], // [cac-geo', 'cac-reu'],
    },
  },
  _maxNes: {
    calc: {
      add: ['$nas-nes', 2],
    },
  },
  _minNes: {
    calc: {
      add: ['$nas-nes'],
    },
  },
  _maxDac: {
    calc: {
      add: [
        2,
        // 'una-atm',
        // 'ele-hyc-atm',
        // 'ele-bio-atm',
        // 'rnc-hyc-atm',
        // 'rnc-bio-atm',
        // 'tra-hyc-atm',
        // 'tra-bio-atm',
        // 'ind-hyc-atm',
        // 'ind-bio-atm',
        // 'ind-pro-atm',
        // 'ind-neb-atm',
      ],
    },
  },
};
export const co2data = [
  {
    'ele-hyc-atm': [2.48013, 1.74693, 0.7876, 0.2789, 0.18322, 0.07818],
    'ele-bio-atm': [0.94275, 0.68781, 0.1701, 0.08481, 0.07043, 0.04807],
    // SUM:        [	3.42289,	0.36372,	0.95770,	0.36372,	0.25366,	0.12626],
    'ele-hwc-cac': [0.07655, 0.21444, 0.34976, 0.4239, 0.56696, 0.67391],
    'ele-bwc-cac': [0, 0.0, 0.0, 0.0, 0.0, 0.00001],
    // SUM:        [	0.07655,	0.42390,	0.34976,	0.42390,	0.56696,	0.67392],
    'una-hwc-cac': [0.22477, 0.62595, 1.09046, 1.29352, 1.40487, 1.34986],
    'una-bwc-cac': [0.0, 0.0, 0.0, 0.0, 0.0, 0.00002],
    // SUM:      : [	0.22477,	1.29352,	1.09046,	1.29352,	1.40487,	1.34988],
    'una-atm': [0, 0, 0, 0, 0, 0],
    //             [		,		,		,		,		,		],
    'rnc-hyc-atm': [2.43572, 2.2737, 2.07915, 1.78687, 1.484, 1.25627],
    'rnc-bio-atm': [3.13138, 2.8228, 2.65284, 2.52236, 2.29388, 1.9695],
    // SUM:      : [	5.56710,	4.30923,	4.73199,	4.30923,	3.77788,	3.22578],
    'tra-hyc-atm': [5.56247, 4.35253, 3.09972, 2.16707, 1.48948, 1.10463],
    'tra-bio-atm': [0.07661, 0.05073, 0.04013, 0.03708, 0.0348, 0.03039],
    // SUM:        [	5.63909,	2.20416,	3.13986,	2.20416,	1.52429,	1.13502],
    'ind-hyc-atm': [4.16707, 3.74283, 3.1831, 2.55849, 2.12141, 1.79013],
    'ind-bio-atm': [0.5572, 0.5331, 0.5338, 0.60406, 0.82069, 1.10112],
    'ind-pro-atm': [1.38934, 1.0346, 0.61069, 0.37991, 0.30307, 0.29163],
    'ind-neb-atm': [0.00084, 0.00011, 0.0005, 0.0048, 0.00611, 0.0006],
    // SUM:        [	6.11446,	3.54728,	4.32811,	3.54728,	3.25130,	3.18350],
    'ind-cac': [0.26311, 0.72202, 1.22991, 1.41756, 1.50082, 1.38114],
    //             [		,		,		,		,		,		],
    'dac-geo': [0, 0, 0, 0, 0, 0], // -------------------
    'cac-reu': [0, 0, 0, 0, 0, 0], // -------------------
    'nas-nes': [-1.30963, 1.57842, 4.00245, 4.6075, 6.73669, 8.18124], // ---------------------
    ...commonCalc,
  },

  {
    'ele-hyc-atm': [2.90783, 2.09433, 1.26261, 0.77975, 0.58223, 0.46566],
    'ele-bio-atm': [0.37645, 0.53403, 0.72492, 0.91206, 1.07631, 1.22214],
    // SUM:        [	3.28428,	2.62837,	1.98753,	1.69182,	1.65854,	1.68781],
    'ele-hwc-cac': [0.01553, 0.1772, 0.53482, 0.77215, 0.84382, 0.83334],
    'ele-bwc-cac': [0.00004, 0.00562, 0.03249, 0.06133, 0.08602, 0.11209],
    // SUM:        [	0.01558,	0.18283,	0.56731,	0.83348,	0.92985,	0.94543],
    'una-hwc-cac': [0.23988, 0.41296, 0.67352, 0.9752, 1.15619, 1.2217],
    'una-bwc-cac': [0.00186, 0.00749, 0.01835, 0.03695, 0.05198, 0.0635],
    // SUM:      : [	0.24174,	0.42046,	0.69187,	1.01216,	1.20818,	1.28521],
    'una-atm': [1.9199, 1.66169, 1.40499, 1.17082, 0.99307, 0.84656],
    //             [		,		,		,		,		,		],
    'rnc-hyc-atm': [2.1987, 1.80822, 1.40816, 1.09824, 0.88188, 0.70993],
    'rnc-bio-atm': [4.15593, 4.05682, 3.92702, 3.76691, 3.57394, 3.37514],
    // SUM:      : [	6.35463,	5.86504,	5.33519,	4.86516,	4.45582,	4.08507],
    'tra-hyc-atm': [7.11786, 6.34333, 5.37626, 4.30323, 3.37443, 2.5639],
    'tra-bio-atm': [0.60737, 0.87756, 1.11573, 1.33802, 1.48628, 1.66293],
    // SUM:        [	7.72524,	7.22089,	6.49199,	5.64125,	4.86071,	4.22684],
    'ind-hyc-atm': [4.86728, 4.42981, 4.0873, 3.76529, 3.59333, 3.44907],
    'ind-bio-atm': [1.02501, 1.16476, 1.33182, 1.50541, 1.71401, 1.90225],
    'ind-pro-atm': [2.06662, 1.98975, 1.77432, 1.41421, 1.22516, 1.11351],
    'ind-neb-atm': [0.01787, 0.03395, 0.05116, 0.0684, 0.08505, 0.09994],
    // SUM:        [	7.97680,	7.61828,	7.24462,	6.75333,	6.61757,	6.56479],
    'ind-cac': [0.12762, 0.25204, 0.51191, 0.88764, 1.08145, 1.19106],
    //             [		,		,		,		,		,		],
    'dac-geo': [0, 0, 0, 0, 0, 0],
    'cac-reu': [0, 0, 0, 0, 0, 0],
    'nas-nes': [-1.81378, -1.20922, -0.76418, -0.48293, -0.23242, 0.01193],
    // //             [		,		,		,		,		,		],
    // 'cac-geo': [0.38495, 0.85534, 1.7711, 2.73328, 3.21948, 3.42171],
    // //             [		,		,		,		,		,		],
    // 'atm-pho': [4.37078, 5.47104, 6.43734, 7.20618, 7.84119, 8.44996],
    // 'pho-nas': [4.37078, 5.47104, 6.43734, 7.20618, 7.84119, 8.44996],
    // 'nas-bio': [6.18265, 6.66714, 7.15067, 7.59082, 7.93561, 8.26242],
    // 'nas-bwc': [0.00191, 0.01312, 0.05084, 0.09828, 0.13801, 0.1756],
    // //             [		,		,		,		,		,		],
    // 'atm-nta': [22.89009, 19.52326, 16.027, 12.91622, 10.74453, 8.96113],
    ...commonCalc,
  },
  {
    'ele-hyc-atm': [3.34052, 2.08054, 0.94302, 0.74967, 0.60247, 0.31587],
    'ele-bio-atm': [0.15851, 0.27077, 0.93289, 1.22551, 1.11545, 0.68848],
    // SUM:        [3.49903, 2.35131, 1.87592, 1.97519, 1.71793, 1.00435],
    'ele-hwc-cac': [0, 0.21437, 0.3719, 0.70143, 1.31229, 2.5318],
    'ele-bwc-cac': [0, 0.00613, 0.23027, 0.79619, 1.59513, 2.44552],
    // SUM:        [0, 0.22051, 0.60217, 1.49763, 2.90742, 4.97732],
    'una-hwc-cac': [0, 0.12993, 0.21197, 0.42876, 0.83893, 1.62128],
    'una-bwc-cac': [0, 0, 0, 0, 0, 0],
    // SUM:      : [0, 0.12993, 0.21197, 0.42876, 0.83893, 1.62128],
    'una-atm': [0.24817, 0.11906, 0.04135, 0.04435, 0.05218, 0.0611],
    //             [, , , , ,],
    'rnc-hyc-atm': [4.06829, 2.75388, 1.41509, 1.47366, 1.71238, 2.0092],
    'rnc-bio-atm': [3.46862, 3.32682, 3.17229, 3.02194, 2.86973, 2.71631],
    // SUM:      : [7.53692, 6.08070, 4.58739, 4.49561, 4.58212, 4.72552],
    'tra-hyc-atm': [6.30356, 5.39028, 3.97542, 3.86351, 3.97149, 4.05448],
    'tra-bio-atm': [0.17928, 0.48394, 1.22533, 1.58022, 1.74278, 1.91169],
    // SUM:        [6.48285, 5.87423, 5.20075, 5.44374, 5.71427, 5.96618],
    'ind-hyc-atm': [5.88005, 4.34548, 2.48135, 2.62186, 3.04494, 3.50312],
    'ind-bio-atm': [1.02594, 1.09786, 1.16072, 1.25766, 1.36249, 1.47268],
    'ind-pro-atm': [1.66682, 1.54495, 1.50447, 1.56341, 1.6249, 1.68217],
    'ind-neb-atm': [0, 0, 0, 0, 0, 0],
    // SUM:        [8.57282, 6.98831, 5.14655, 5.44294, 6.03235, 6.65799],
    'ind-cac': [0, 0.02475, 0.16531, 0.34557, 0.49471, 0.62034],
    //             [, , , , ,],
    'dac-geo': [0, 0, 0, 0, 0, 0],
    'cac-reu': [0, 0, 0, 0, 0, 0],
    'nas-nes': [-1.25958, 0.13721, 2.09317, 2.60481, 3.2818, 3.29712],
    // //             [, , , , ,],
    // 'cac-geo': [0, 0.3752, 0.97945, 2.27197, 4.24107, 7.21895],
    // //             [, , , , ,],
    // 'atm-pho': [3.57278, 5.32274, 8.81469, 10.48638, 11.96741, 12.53182],
    // 'pho-nas': [3.57278, 5.32274, 8.81469, 10.48638, 11.96741, 12.53182],
    // 'nas-bio': [4.83236, 5.1794, 6.49124, 7.08536, 7.09047, 6.78917],
    // 'nas-bwc': [0, 0.00613, 0.23027, 0.79619, 1.59513, 2.44552],
    // //             [, , , , ,],
    // 'atm-nta': [22.76703, 16.09089, 8.03729, 6.91547, 6.13146, 5.88333],
    ...commonCalc,
  },
  {
    'ele-hyc-atm': [1.12216, 0.53009, 0.12526, 0.03664, 0.01943, 0.015],
    'ele-bio-atm': [0.12335, 0.1148, 0.10087, 0.07957, 0.05103, 0.02356],
    // SUM:        [	1.24551,	0.64490,	0.22613,	0.11622,	0.07046,	0.03856],
    'ele-hwc-cac': [0.01162, 0.04234, 0.09394, 0.14645, 0.18222, 0.19768],
    'ele-bwc-cac': [0.02921, 0.09199, 0.1919, 0.29534, 0.34468, 0.34323],
    // SUM:        [	0.04083,	0.13434,	0.28585,	0.44180,	0.52691,	0.54092],
    'una-hwc-cac': [0.0054, 0.01569, 0.02935, 0.04105, 0.05454, 0.07881],
    'una-bwc-cac': [0.38383, 1.46409, 3.84676, 7.1165, 10.02274, 12.07292],
    // SUM:      : [	0.38924,	1.47978,	3.87612,	7.15755,	10.07729,	12.15173],
    'una-atm': [0, 0, 0, 0, 0, 0],
    //             [		,		,		,		,		,		],
    'rnc-hyc-atm': [2.00883, 1.90135, 1.80481, 1.78212, 1.73742, 1.61927],
    'rnc-bio-atm': [2.9454, 2.43555, 2.06266, 1.62687, 1.23672, 0.92572],
    // SUM:      : [	4.95423,	4.33690,	3.86748,	3.40899,	2.97415,	2.54500],
    'tra-hyc-atm': [7.22773, 6.84719, 6.65438, 5.85278, 5.22772, 4.67525],
    'tra-bio-atm': [0.35532, 0.51027, 0.86515, 1.23839, 1.54389, 1.76046],
    // SUM:        [	7.58305,	7.35746,	7.51954,	7.09118,	6.77162,	6.43571],
    'ind-hyc-atm': [5.18311, 5.34187, 5.30614, 5.59545, 5.51748, 5.33093],
    'ind-bio-atm': [2.41325, 2.67089, 2.45615, 2.15985, 1.8126, 1.45159],
    'ind-pro-atm': [1.03974, 0.66353, 0.31867, 0.29517, 0.2779, 0.26125],
    'ind-neb-atm': [0, 0, 0, 0, 0, 0],
    // SUM:        [	8.63612,	8.67630,	8.08097,	8.05048,	7.60799,	7.04377],
    'ind-cac': [0, 0, 0, 0, 0, 0],
    //             [		,		,		,		,		,		],
    'dac-geo': [0, 0, 0, 0, 0, 0],
    'cac-reu': [0, 0, 0, 0, 0, 0],
    'nas-nes': [-0.84674, 0.28346, 0.61083, 0.63564, 0.72015, 1.21955],
    // //             [		,		,		,		,		,		],
    // 'cac-geo': [0.43007, 1.61412, 4.16197, 7.59936, 10.6042, 12.69265],
    // //             [		,		,		,		,		,		],
    // 'atm-pho': [5.40363, 7.57107, 10.13435, 13.15219, 15.73184, 17.79705],
    // 'pho-nas': [5.40363, 7.57107, 10.13435, 13.15219, 15.73184, 17.79705],
    // 'nas-bio': [5.83733, 5.73153, 5.48484, 5.1047, 4.64426, 4.16134],
    // 'nas-bwc': [0.41304, 1.55608, 4.03867, 7.41185, 10.36742, 12.41615],
    // //             [		,		,		,		,		,		],
    // 'atm-nta': [17.0153, 13.4445, 9.55978, 5.51468, 1.69239, -1.734],
    ...commonCalc,
  },
  {
    'ele-hyc-atm': [2.83932, 1.37752, 0.28277, 0.0025, 0.0011, 0.00072],
    'ele-bio-atm': [0.13878, 0.13026, 0.11627, 0.09478, 0.06578, 0.03743],
    // SUM:        [	2.97811,	1.50779,	0.39905,	0.09728,	0.06689,	0.03816],
    'ele-hwc-cac': [0.00462, 0.02133, 0.04663, 0.06439, 0.06857, 0.06733],
    'ele-bwc-cac': [0.00127, 0.00255, 0.00254, 0.00251, 0.00246, 0.00235],
    // SUM:        [	0.00589,	0.02389,	0.04918,	0.06691,	0.07103,	0.06968],
    'una-hwc-cac': [0.0609, 0.33675, 0.90914, 1.44457, 1.63526, 1.62255],
    'una-bwc-cac': [0.24175, 1.37867, 3.63052, 5.43811, 6.31947, 7.22315],
    // SUM:      : [	0.30266,	1.71543,	4.53967,	6.88269,	7.95473,	8.84571],
    'una-atm': [0, 0, 0, 0, 0, 0],
    //             [		,		,		,		,		,		],
    'rnc-hyc-atm': [1.87498, 1.30747, 0.94295, 0.73248, 0.62013, 0.5364],
    'rnc-bio-atm': [3.2184, 2.52434, 2.06744, 1.59832, 1.17828, 0.84074],
    // SUM:      : [	5.09339,	3.83181,	3.01040,	2.33081,	1.79842,	1.37714],
    'tra-hyc-atm': [7.71495, 6.1802, 4.78192, 3.97882, 3.35071, 3.18165],
    'tra-bio-atm': [0, 0, 0, 0, 0, 0],
    // SUM:        [	7.71495,	6.18020,	4.78192,	3.97882,	3.35071,	3.18165],
    'ind-hyc-atm': [6.07359, 4.32292, 3.0909, 2.6355, 2.42675, 2.21099],
    'ind-bio-atm': [1.47182, 1.75063, 1.58021, 1.32463, 1.07052, 0.84288],
    'ind-pro-atm': [1.46175, 1.41081, 1.34967, 1.28106, 1.20934, 1.13532],
    'ind-neb-atm': [0, 0, 0, 0, 0, 0],
    // SUM:        [	9.00717,	7.48437,	6.02079,	5.24120,	4.70663,	4.18920],
    'ind-cac': [0, 0, 0, 0, 0, 0],
    //             [		,		,		,		,		,		],
    'dac-geo': [0, 0, 0, 0, 0, 0],
    'cac-reu': [0, 0, 0, 0, 0, 0],
    'nas-nes': [-4.12899, -0.31517, 4.48103, 5.3098, 4.90735, 4.48552],
    // //             [		,		,		,		,		,		],
    // 'cac-geo': [0.30856, 1.73932, 4.58885, 6.94961, 8.02577, 8.91539],
    // //             [		,		,		,		,		,		],
    // 'atm-pho': [0.94305, 5.47129, 11.87804, 13.76819, 13.54389, 13.4321],
    // 'pho-nas': [0.94305, 5.47129, 11.87804, 13.76819, 13.54389, 13.4321],
    // 'nas-bio': [4.82901, 4.40524, 3.76393, 3.01774, 2.31459, 1.72106],
    // 'nas-bwc': [0.24302, 1.38123, 3.63307, 5.44063, 6.32193, 7.2255],
    // //             [		,		,		,		,		,		],
    // 'atm-nta': [23.85058, 13.53289, 2.33413, -2.12006, -3.62122, -4.64593],
    ...commonCalc,
  },
];
